module.exports = __webpack_public_path__ + "9c93764ef2d029fd9870246ba45c31f3.svg";